import { useMessageStore } from "@/stores/useMessageStore";

/** Narrow subscription for per-conversation SSE running state. */
export function useConversationRunning(conversationId: string): boolean {
  return useMessageStore(
    (s) => s.isRunningByConversation[conversationId] ?? false,
  );
}
